import { formatBrl } from '../../lib/format';
import { Card } from './Card';

interface Props {
  balanceCents: number;
  equityCents: number;
  unrealizedPnlCents: number;
}

function ResultCell({
  label,
  value,
  tone,
}: {
  label: string;
  value: string;
  tone?: 'pos' | 'neg' | 'neutral';
}) {
  const color =
    tone === 'pos' ? 'text-success-300' : tone === 'neg' ? 'text-danger-300' : 'text-ink-100';
  return (
    <div className="px-5 py-4 text-center">
      <p className="text-2xs text-ink-400 font-semibold uppercase tracking-widest">{label}</p>
      <p className={'mt-1.5 text-xl font-bold tabular-nums ' + color}>{value}</p>
    </div>
  );
}

export function CurrentResults({ balanceCents, equityCents, unrealizedPnlCents }: Props) {
  const tone = unrealizedPnlCents > 0 ? 'pos' : unrealizedPnlCents < 0 ? 'neg' : 'neutral';
  return (
    <Card title="Resultados atuais">
      <div className="divide-ink-800 grid grid-cols-1 divide-y sm:grid-cols-3 sm:divide-x sm:divide-y-0">
        <ResultCell label="Balance" value={formatBrl(balanceCents)} />
        <ResultCell label="Equidade" value={formatBrl(equityCents)} />
        <ResultCell label="PnL não realizado" value={formatBrl(unrealizedPnlCents)} tone={tone} />
      </div>
    </Card>
  );
}
